module.exports = __webpack_public_path__ + "img/logo-round.f535bd01.png";